<template>
  <v-card
    class="info-paciente-card rounded-xl"
    elevation="2"
    height="180"
    width="100%"
  >
    <v-toolbar
      color="transparent"
      class="toolbar-main"
    >
      <!-- Logo e Brand -->
      <v-row
        no-gutters
        align="center"
        class="brand-section"
      >
        <v-col
          v-if="!isAutoLogin"
          cols="auto"
        >
          <div class="logo-container">
            <img
              :src="require(`@/assets/DRmed-01.png`)"
              class="ml-4"
              width="200"
              alt="DrMedPro"
            >
          </div>
        </v-col>
                
        <v-divider
          v-if="!isAutoLogin && dadosPaciente && Object.keys(dadosPaciente).length > 0"
          vertical
          class="divider-separator ml-4"
        />
                
        <!-- Informações do Paciente -->
        <v-col
          v-if="dadosPaciente && Object.keys(dadosPaciente).length > 0"
          cols="auto"
        >
          <div class="patient-header d-flex align-center px-4">
            <div class="patient-avatar-container mr-3">
              <v-avatar
                size="44"
                class="patient-avatar"
              >
                <v-img src="https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png" />
              </v-avatar>
              <div
                class="status-indicator"
                :class="getPatientStatus()"
              />
            </div>
            <div class="patient-info">
              <div class="patient-name">
                {{ dadosPaciente.nomePaciente || dadosPaciente.paciente }}
              </div>
              <div class="patient-tags d-flex mt-2">
                <v-chip
                  v-if="dadosPaciente.atendimento"
                  size="small"
                  class="tag-primary mr-2"
                >
                  <v-icon
                    x-small
                    left
                  >
                    medical_services
                  </v-icon>
                  {{ dadosPaciente.atendimento }}
                </v-chip>
                <v-chip
                  v-if="dadosPaciente.tipoAtendimento"
                  size="small"
                  class="tag-secondary"
                >
                  <v-icon
                    x-small
                    left
                  >
                    confirmation_number
                  </v-icon>
                  {{ dadosPaciente.tipoAtendimento }}
                </v-chip>
              </div>
            </div>
            
            <div class="patient-actions">
              <v-chip
                title="Voltar"
                size="small"
                class="action-chip back-chip mr-2"
                @click="voltarPagina"
              >
                <v-icon
                  size="small"
                  class="mr-1"
                >
                  arrow_back
                </v-icon>
                Voltar
              </v-chip>
              <v-chip
                title="Chamar paciente"
                size="small"
                class="action-chip call-chip"
                :disabled="!canCall"
                @click="chamarPaciente"
              >
                <v-icon
                  size="small"
                  class="mr-1"
                >
                  record_voice_over
                </v-icon>
                Chamar
              </v-chip>
            </div>
          </div>
        </v-col>
      </v-row>
      
     
      <v-spacer />
     
      <div
        v-if="!isAutoLogin"
        class="doctor-info-section"
      >
        <v-card
          variant="flat"
          class="doctor-card rounded-lg"
        >
          <v-list-item class="doctor-list-item py-1">
            <template #prepend>
              <div class="doctor-avatar-container">
                <v-avatar
                  size="34"
                  class="doctor-avatar"
                >
                  <v-icon
                    color="white"
                    size="small"
                  >
                    person
                  </v-icon>
                </v-avatar>
              </div>
            </template>
            <v-list-item-title class="doctor-name py-0">
              {{ user?.tecnico ? '' : 'Dr(a). ' }}{{ nomeFormatado(user?.nome || '') }}
            </v-list-item-title>
          </v-list-item>
        </v-card>
      </div>
    </v-toolbar>

    <!-- Área Expandida - Detalhes do Paciente -->
    <v-expand-transition>
      <div
        v-if="expanded && dadosPaciente && Object.keys(dadosPaciente).length > 0"
        class="patient-details-section"
      >
        <v-divider class="details-divider" />
        <v-container
          fluid
          class="details-container pa-0"
        >
          <v-row
            dense
            class="patient-details-grid"
          >
            <!-- Dados Pessoais -->
            <v-col
              cols="12"
              sm="6"
              md="2"
              lg="2"
            >
              <div class="detail-group">
                <div class="detail-item">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    cake
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">Nascimento</span>
                    <span class="detail-value">{{ dadosPaciente.dataNascimento }}</span>
                  </div>
                </div>
                <div class="detail-item mt-2 rounded-bs-xl">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    schedule
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">Idade</span>
                    <span class="detail-value highlight-value">{{ dadosPaciente.idade }}</span>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Convênio e Sexo -->
            <v-col
              cols="12"
              sm="6"
              md="2"
              lg="2"
            >
              <div class="detail-group">
                <div class="detail-item">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    local_hospital
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">Convênio</span>
                    <span class="detail-value">{{ dadosPaciente.convenio }}</span>
                  </div>
                </div>
                <div class="detail-item mt-2">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    female
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">Sexo</span>
                    <span class="detail-value">{{ dadosPaciente.sexo }}</span>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Documentos -->
            <v-col
              cols="12"
              sm="6"
              md="2"
              lg="2"
            >
              <div class="detail-group">
                <div class="detail-item">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    badge
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">CPF</span>
                    <span class="detail-value code-value">{{ dadosPaciente.CPF }}</span>
                  </div>
                </div>
                <div class="detail-item mt-2">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    assignment
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">RG</span>
                    <span class="detail-value code-value">{{ dadosPaciente.RG }}</span>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Localização e Solicitante -->
            <v-col
              cols="12"
              sm="6"
              md="3"
              lg="4"
            >
              <div class="detail-group">
                <div class="detail-item">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    location_on
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">Cidade</span>
                    <span class="detail-value">{{ dadosPaciente.cidade }}</span>
                  </div>
                </div>
                <div class="detail-item mt-2 rounded-be-xl">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    person_search
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">Solicitante</span>
                    <span class="detail-value highlight-value">{{ dadosPaciente.solicitante }}</span>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Profissão e NPS -->
            <v-col
              cols="12"
              sm="6"
              md="2"
              lg="2"
            >
              <div class="detail-group">
                <div class="detail-item">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    work
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">Profissão</span>
                    <span class="detail-value">{{ dadosPaciente.profissao }}</span>
                  </div>
                </div>
                <div class="detail-item mt-2 rounded-be-xl">
                  <v-icon
                    small
                    class="detail-icon"
                  >
                    sentiment_satisfied
                  </v-icon>
                  <div class="detail-content">
                    <span class="detail-label">NPS</span>
                    <span class="detail-value">{{ dadosPaciente.notaNps }}</span>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-expand-transition>
  </v-card>
</template>
<script>
import { ref, onMounted, watch, computed } from 'vue'
import medicoService from '../../../services/medico.service'

export default {
    name: 'PacienteToolbarFixed',
    props: {
        idOrdemServico: {
            type: [String, Number],
            required: true
        },
        expanded: {
            type: Boolean,
            default: true
        },
        user: {
            type: Object,
            default: () => ({})
        },
        item: {
            type: Object,
            default: () => ({})
        },
        ficha: {
            type: Object,
            default: () => ({})
        },
        
    },
    emits: ['help-requested', 'logout', 'paciente-carregado', 'voltar', 'chamada-realizada', 'chamada-erro'],

    setup(props, { emit }) {
        const dadosPaciente = ref({})
        const loading = ref(false)
        const calling = ref(false)
        const mItem = ref(0)
        const colorItem = ref(null)
        const isAutoLogin = computed(() => Boolean(props.user?.autoLogin))
        const canCall = computed(() => Boolean(props.ficha?.idAtendimento) && !calling.value)

        const nomeFormatado = (nome) => {
            if (!nome) return ''
            return nome.split(' ').map(word =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            ).join(' ')
        }

        const getPatientStatus = () => {
            if (dadosPaciente.value.tipoAtendimento?.includes('Emergência')) {
                return 'status-emergency'
            } else if (dadosPaciente.value.tipoAtendimento?.includes('Urgência')) {
                return 'status-urgent'
            }
            return 'status-stable'
        }

        const retornarInformacoesPacienteOs = async (idOrdemServico) => {
            if (!idOrdemServico) return

            loading.value = true
            try {
                const response = await medicoService.medico.retornarInformacoesPacienteOs(idOrdemServico)

                if (response.status === 200) {
                    dadosPaciente.value = {
                        ...response.data,
                        nome: response.data.nomePaciente
                    }
                    emit('paciente-carregado', dadosPaciente.value)
                }
            } catch (error) {
                console.error('Erro ao buscar informações do paciente:', error)
                dadosPaciente.value = {}
            } finally {
                loading.value = false
            }
        }

        const retornarHelp = () => {
            emit('help-requested')
        }

        const logout = () => {
            emit('logout')
        }

        const voltarPagina = () => {
            emit('voltar')
        }


        const chamarPaciente = async () => {
            if (!canCall.value) return

            const ficha = props.ficha || {}
            const user = props.user || {}
            const statusAtual = ficha.status
            const nomeConsultorio = user.nomeConsultorio || user.nomeConsultorioServicos?.nomeConsultorio || ''

            calling.value = true
            try {
                const response = await medicoService.medico.fazerChamada(
                    ficha.idAtendimento,
                    ficha.codigo,
                    nomeConsultorio,
                    ficha.idConsulta,
                    user.nome,
                    ficha.nomePaciente || dadosPaciente.value.nomePaciente || dadosPaciente.value.paciente || '',
                    ficha.prioridade || 0,
                    `${user.idLocal}`,
                    user.nomeLocal || '',
                    user.tecnico || 0,
                    false,
                    user.idLocal,
                    ficha.idPaciente || dadosPaciente.value.idPaciente,
                    ficha.dataNascimento || dadosPaciente.value.dataNascimento
                )

                if (response?.data === true) {
                    emit('chamada-realizada', { idAtendimento: ficha.idAtendimento, status: statusAtual })
                }
            } catch (error) {
                console.error('Erro ao chamar paciente:', error)
                emit('chamada-erro', error)
            } finally {
                calling.value = false
            }
        }

        watch(() => props.idOrdemServico, (newId) => {
            if (newId) {
                retornarInformacoesPacienteOs(newId)
            }
        })

        onMounted(() => {
            if (props.idOrdemServico) {
                retornarInformacoesPacienteOs(props.idOrdemServico)
            }
        })

        return {
            dadosPaciente,
            loading,
            mItem,
            colorItem,
            nomeFormatado,
            getPatientStatus,
            retornarHelp,
            logout,
            voltarPagina,
            chamarPaciente,
            calling,
            canCall,
            isAutoLogin
        }
    }
}
</script>

<style scoped>
/* Card Principal com Gradiente */
.info-paciente-card {
    background: linear-gradient(135deg, rgb(var(--v-theme-primary)), rgb(var(--v-theme-secondary))) !important;
    color: rgb(var(--v-theme-on-primary)); /* Ajustado para tema */
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
}

.info-paciente-card:hover {
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.2) !important;
    transform: translateY(-2px);
}

.toolbar-main {
    min-height: 72px !important;
    padding: 0 16px;
    position: relative;
}

/* Brand Section */
.brand-section {
    flex: 0 0 auto;
}

.brand-logo {
    align-items: center;
}

.logo-container {
    display: flex;
    align-items: center;
    height: 100%;
}

.logo-container img {
    filter: brightness(0) invert(1);
}

html[data-theme="dark"] .logo-container img {
    filter: none;
}

.brand-text {
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
    font-size: 1.4rem;
    color: rgb(var(--v-theme-on-primary)); /* Ajustado para tema */
    letter-spacing: -0.5px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.brand-accent {
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    font-size: 1.4rem;
    background: linear-gradient(135deg, #FFFFFF, #E2E8F0);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-left: 2px;
    text-shadow: none;
}

.divider-separator {
    border-color: rgba(var(--v-theme-on-primary), 0.3) !important; /* Ajustado para tema */
    height: 40px;
}

/* Patient Header */
.patient-header {
    min-width: 280px;
    gap: 8px;
}

.patient-avatar-container {
    position: relative;
}

.patient-avatar {
    border: 3px solid rgba(var(--v-theme-on-primary), 0.3); /* Ajustado para tema */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
}

.patient-avatar:hover {
    border-color: rgba(var(--v-theme-on-primary), 0.6); /* Ajustado para tema */
    transform: scale(1.05);
}

.status-indicator {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid rgb(var(--v-theme-surface)); /* Ajustado para tema */
}

.status-stable {
    background: linear-gradient(135deg, #48BB78, #38A169);
}

.status-urgent {
    background: linear-gradient(135deg, #ED8936, #DD6B20);
}

.status-emergency {
    background: linear-gradient(135deg, #E53E3E, #C53030);
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.2); opacity: 0.7; }
    100% { transform: scale(1); opacity: 1; }
}

.patient-info {
    flex: 1;
}

.patient-name {
    font-size: 1.1rem;
    font-weight: 700;
    color: rgb(var(--v-theme-on-primary)); /* Ajustado para tema */
    line-height: 1.2;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.patient-tags {
    gap: 8px;
}

.tag-primary {
    background: rgba(var(--v-theme-on-primary), 0.2) !important; /* Ajustado para tema */
    backdrop-filter: blur(10px);
    color: rgb(var(--v-theme-on-primary)) !important; /* Ajustado para tema */
    font-weight: 600;
    border: 1px solid rgba(var(--v-theme-on-primary), 0.3); /* Ajustado para tema */
}

.tag-secondary {
    background: rgba(var(--v-theme-on-primary), 0.15) !important; /* Ajustado para tema */
    backdrop-filter: blur(10px);
    color: rgb(var(--v-theme-on-primary)) !important; /* Ajustado para tema */
    font-weight: 600;
    border: 1px solid rgba(var(--v-theme-on-primary), 0.2); /* Ajustado para tema */
}

/* Doctor Info Section */
.doctor-info-section {
    margin-right: 12px;
}

.doctor-card {
    background: rgba(var(--v-theme-on-primary), 0.15) !important; /* Ajustado para tema */
    backdrop-filter: blur(10px);
    border: 1px solid rgba(var(--v-theme-on-primary), 0.2); /* Ajustado para tema */
}

.doctor-list-item {
    padding: 0 12px;
    min-height: auto;
}

.doctor-avatar-container {
    margin-right: 10px;
}

.doctor-avatar {
    background: rgba(var(--v-theme-on-primary), 0.2) !important; /* Ajustado para tema */
    backdrop-filter: blur(10px);
    border: 1px solid rgba(var(--v-theme-on-primary), 0.3); /* Ajustado para tema */
}

.doctor-name {
    font-size: 0.85rem;
    font-weight: 600;
    color: rgb(var(--v-theme-on-primary)); /* Ajustado para tema */
    line-height: 1.2;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* Action Buttons */
.action-buttons {
    display: flex;
    gap: 4px;
}

.patient-actions {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: 8px;
}

.action-chip {
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.action-chip:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.back-chip {
    background: rgba(var(--v-theme-warning), 0.15) !important;
    color: rgb(var(--v-theme-warning)) !important;
    border: 1px solid rgba(var(--v-theme-warning), 0.4) !important;
}

.call-chip {
    background: rgba(var(--v-theme-primary), 0.2) !important;
    color: rgb(var(--v-theme-on-primary)) !important;
    border: 1px solid rgba(var(--v-theme-primary), 0.5) !important;
}


/* Patient Details Section */
.patient-details-section {
    background-color: rgb(var(--v-theme-surface));
    border-top: 1px solid rgba(var(--v-theme-on-surface), 0.12);
}

.details-divider {
    border-color: rgba(var(--v-theme-on-surface), 0.12) !important;
}

.details-container {
    max-width: 100%;
}

.patient-details-grid {
    margin: 0 -6px;
}

.detail-group {
    padding: 0 6px;
}

.detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 10px;
    background-color: rgba(var(--v-theme-on-surface), 0.04);
    border-radius: 8px;
    border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
    transition: all 0.2s ease;
    min-height: 44px;
}

.detail-item:hover {
    border-color: rgba(var(--v-theme-primary), 0.3);
    background-color: rgba(var(--v-theme-on-surface), 0.08);
    transform: translateY(-1px);
}

.detail-icon {
    color: rgb(var(--v-theme-primary));
    opacity: 0.8;
    flex-shrink: 0;
}

.detail-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1;
}

.detail-label {
    font-size: 0.7rem;
    color: rgba(var(--v-theme-on-surface), 0.6);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1;
}

.detail-value {
    font-size: 0.8rem;
    font-weight: 600;
    color: rgb(var(--v-theme-on-surface));
    line-height: 1.2;
    word-break: break-word;
}

.highlight-value {
    color: rgb(var(--v-theme-primary));
}

.code-value {
    font-family: 'Roboto Mono', monospace;
    font-size: 0.75rem;
    background: rgba(var(--v-theme-primary), 0.05);
    padding: 2px 6px;
    border-radius: 4px;
    display: inline-block;
}

/* Responsividade */
@media (max-width: 1279px) {
    .patient-header {
        min-width: 240px;
    }
    
    .brand-text,
    .brand-accent {
        font-size: 1.25rem;
    }
}

@media (max-width: 959px) {
    .toolbar-main {
        min-height: 64px !important;
        padding: 0 12px;
    }
    
    .patient-header {
        min-width: 200px;
    }
    
    .patient-name {
        font-size: 1rem;
    }
    
    .doctor-info-section {
        margin-right: 8px;
    }
    
    .doctor-list-item {
        padding: 0 8px;
    }
    
    .patient-details-grid {
        margin: 0 -4px;
    }
    
    .detail-group {
        padding: 0 4px;
    }
    
    .detail-item {
        padding: 4px 8px;
        min-height: 40px;
    }
}

@media (max-width: 767px) {
    .toolbar-main {
        padding: 0 8px;
    }
    
    .brand-logo {
        margin-left: 0;
    }
    
    .patient-header {
        min-width: auto;
        padding-left: 8px;
    }
    
    .details-container {
        padding: 8px !important;
    }
    
    .patient-details-grid {
        margin: 0 -2px;
    }
    
    .detail-group {
        padding: 0 2px;
    }
    
    .detail-item {
        padding: 4px 6px;
        min-height: 36px;
    }
    
    .action-buttons {
        margin-right: 0;
    }
}

@media (max-width: 599px) {
    .brand-section .v-col:first-child {
        display: none;
    }
    
    .divider-separator {
        display: none !important;
    }
    
    .patient-header {
        padding-left: 0;
    }
    
    .doctor-info-section {
        display: none;
    }
    
    .patient-details-grid {
        gap: 8px;
    }
    
    .detail-item {
        min-height: 32px;
    }
    
    .detail-label {
        font-size: 0.65rem;
    }
    
    .detail-value {
        font-size: 0.75rem;
    }
}

/* Animações */
.v-expand-transition-enter-active,
.v-expand-transition-leave-active {
    transition: all 0.3s ease;
}

.v-expand-transition-enter-from,
.v-expand-transition-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}
</style>
